import { render, staticRenderFns } from "./delete_loot.vue?vue&type=template&id=702c2dff&scoped=true"
import script from "./delete_loot.vue?vue&type=script&lang=ts"
export * from "./delete_loot.vue?vue&type=script&lang=ts"
import style0 from "./delete_loot.vue?vue&type=style&index=0&id=702c2dff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702c2dff",
  null
  
)

export default component.exports